var _Symbol$iterator;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
How it works:
`this.#head` is an instance of `Node` which keeps track of its current value and nests another instance of `Node` that keeps the value that comes after it. When a value is provided to `.enqueue()`, the code needs to iterate through `this.#head`, going deeper and deeper to find the last value. However, iterating through every single item is slow. This problem is solved by saving a reference to the last value as `this.#tail` so that it can reference it to add a new value.
*/
var Node = /*#__PURE__*/_createClass(function Node(value) {
  _classCallCheck(this, Node);

  this.value = void 0;
  this.next = void 0;
  this.value = value;
});

var _head = /*#__PURE__*/_classPrivateFieldLooseKey("head");

var _tail = /*#__PURE__*/_classPrivateFieldLooseKey("tail");

var _size = /*#__PURE__*/_classPrivateFieldLooseKey("size");

_Symbol$iterator = Symbol.iterator;

var Queue = /*#__PURE__*/function () {
  function Queue() {
    _classCallCheck(this, Queue);

    Object.defineProperty(this, _head, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _tail, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _size, {
      writable: true,
      value: void 0
    });
    this.clear();
  }

  _createClass(Queue, [{
    key: "enqueue",
    value: function enqueue(value) {
      var node = new Node(value);

      if (_classPrivateFieldLooseBase(this, _head)[_head]) {
        _classPrivateFieldLooseBase(this, _tail)[_tail].next = node;
        _classPrivateFieldLooseBase(this, _tail)[_tail] = node;
      } else {
        _classPrivateFieldLooseBase(this, _head)[_head] = node;
        _classPrivateFieldLooseBase(this, _tail)[_tail] = node;
      }

      _classPrivateFieldLooseBase(this, _size)[_size]++;
    }
  }, {
    key: "dequeue",
    value: function dequeue() {
      var current = _classPrivateFieldLooseBase(this, _head)[_head];

      if (!current) {
        return;
      }

      _classPrivateFieldLooseBase(this, _head)[_head] = _classPrivateFieldLooseBase(this, _head)[_head].next;
      _classPrivateFieldLooseBase(this, _size)[_size]--;
      return current.value;
    }
  }, {
    key: "clear",
    value: function clear() {
      _classPrivateFieldLooseBase(this, _head)[_head] = undefined;
      _classPrivateFieldLooseBase(this, _tail)[_tail] = undefined;
      _classPrivateFieldLooseBase(this, _size)[_size] = 0;
    }
  }, {
    key: "size",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _size)[_size];
    }
  }, {
    key: _Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      var current;
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              current = _classPrivateFieldLooseBase(this, _head)[_head];

            case 1:
              if (!current) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return current.value;

            case 4:
              current = current.next;
              _context.next = 1;
              break;

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, value, this);
    })
  }]);

  return Queue;
}();

export { Queue as default };